export default "__VITE_ASSET__ChRc0dEq__"